<div class="aems-bread-crumb m-b-16">
  <a class="m-r-4" routerLink="/master-data">Master Data</a><span>/ {{ 'Repair Code Part Association' }}</span>
</div>

<form [formGroup]="filterFormGroup" class="list-repair-part-container">
  <div class="pure-g">
    <div class="pure-u-md-10-24 pure-u-lg-14-24">
      <h3 class="inline m-r-4" i18n>Repair Code Part Association</h3>
    </div>
    <div class="pure-u-md-14-24 pure-u-lg-10-24 right">
      <app-repair-part-search
        class="search-bar"
        [repairPartSearchTextForm]="filterFormGroup.controls.repairPartSearchTextForm"></app-repair-part-search>
    </div>
  </div>
  <app-repair-part-filters [filterFormGroup]="filterFormGroup"></app-repair-part-filters>
  <app-repair-part-grid [filterFormGroup]="filterFormGroup" class="table-container"></app-repair-part-grid>
</form>
